export enum VehicleTypeEnum {
  AUTOMOVIL = 'Automóvil',
  CAMIONETA = 'Camioneta',
  BUS = 'Bus',
  MICROBUS = 'Microbus',
  BUSETA = 'Buseta',
  CAMPERO_VAN = 'Campero Van',
}
